export default __webpack_public_path__ + "static/media/small.41ba6c07.jpg";